import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

import { subscribeNotifications } from '../subscribeNotifications/subscribeNotifications';

export const initNotifications = async (): Promise<void> => {
  if (Entities.usersStore?.Me?.id) {
    const isPushNotificationsEnabled = storage.pushNotifications.get(Entities.usersStore.Me.id);

    Entities.pushNotifications.setEnabled(isPushNotificationsEnabled);

    if (isPushNotificationsEnabled !== false) {
      subscribeNotifications();
    }
  }
};
